import { Injectable } from '@angular/core'
import { environment } from '../../environments/environment'

declare global { interface Window { AdobeDC: any } }

@Injectable({
    providedIn: 'root'
})
export class AdobeViewSDKClient {

    adobeDCView: any

    readyPromise: Promise<void> = new Promise((resolve, reject) => {
        if (window.AdobeDC) {
            resolve()
        } else {
            /* Wait for Adobe Document Services PDF Embed API to be ready
            setTimeout(() => {
                alert('Bother Adobe Document Services PDF Embed API is not ready')
            }, 10000)
            */
            throw('Adobe Document Services PDF Embed API is not ready')
            document.addEventListener('adobe_dc_view_sdk.ready', () => {
                resolve()
            })
        }
    })

    ready() {
        return this.readyPromise
    }

    previewFile(document: any, divId: string, viewerConfig: any) {
        const config: any = {
            clientId: environment.adobePDFViewerApiKey,
        }
        if (divId) {
            config.divId = divId
        }
        this.adobeDCView = new window.AdobeDC.View(config)

        const previewFilePromise = this.adobeDCView.previewFile({
            /* Pass information on how to access the file */
            content: {
                location: {
                    url: document.cdn_path
                },
            },
            metaData: {
                fileName: document.cdn_path.split('/').pop(),
                id: 'doc' + document.ncmf_id
            }
        }, viewerConfig)

        return previewFilePromise
    }
}
